export const RUNNING: string  = 'Running';
export const RUN_TESTS: string = 'Run Tests';
export const ENTER_KEY: number = 13;
export const MAC_OS: boolean = navigator.appVersion.includes('Mac');
export const DEFAULT_RUN_CODE_HINT = MAC_OS ? '⌘ + Enter' : 'Ctrl + Enter';
export const RUN_CODE: string = 'Run Code';
export const CLICK_ME: string = 'Click Me';
